/* eslint-disable camelcase */
import React from 'react';
import classnames from 'classnames';
import { isEmpty } from 'lodash';
import { Modal } from 'antd-mobile';
import { connect } from 'umi';
import { Clickable } from '@/components';
import useGCPI18n from '@/hooks/useGCPI18n';
import { getImgUrl } from '@/utils/utils';

import styles from './index.less';

const WinPrizeModal = props => {
  const { visible, prizeDetail, successTip, onCancel, onOk, isPto, claimedPrizeSetting } = props;
  const GCPI18n = useGCPI18n();
  const GameI18n = JSON.parse(window.localStorage.getItem('GAME_i18n'));
  const { rewardName, serverUrl, imageUrl, prizeUrl, rewardMemId } = prizeDetail || {};

  const getImgUlr = () => {
    if (prizeUrl) {
      return prizeUrl;
    }
    return getImgUrl(serverUrl, imageUrl);
  };

  if (!visible) {
    return '';
  }

  return (
    <Modal
      visible
      bodyClassName={`defaultModal ${styles.successModal} ${
        !isEmpty(claimedPrizeSetting) && styles.customModalWrap
      }`}
      onClose={onCancel}
    >
      <div className={styles.contain}>
        {isEmpty(claimedPrizeSetting) ? (
          <>
            <div className={styles.header}>
              <h3>{GCPI18n({ id: 'lb_mian_win_prize_title_ptotemp' })}</h3>
              <p>
                {isPto
                  ? GCPI18n({ id: 'lb_mian_win_prize_tip_ptotemp' })
                  : GCPI18n({ id: 'lb_mian_win_prize_tip_temp' })}
              </p>
            </div>
            <div className={styles.winPrize}>
              <div className={styles.winImg}>
                <img src={getImgUlr()} alt="" />
              </div>
              <p className={styles.winName}>
                {GameI18n[`rewardMem-${rewardMemId}-rewardName`] || rewardName}
              </p>
              {successTip && <p>{successTip}</p>}
              <p className={styles.thank}>{GCPI18n({ id: 'lb_mian_thanks_ptotemp' })}</p>
            </div>
          </>
        ) : (
          <>
            <div className={styles.winPrize}>
              <div className={classnames(styles.winImg, styles.customWinImg)}>
                <img
                  src={getImgUrl(claimedPrizeSetting?.serverUrl, claimedPrizeSetting?.mediaUrl)}
                  alt=""
                />
              </div>
              <p>{claimedPrizeSetting?.brief}</p>
            </div>
          </>
        )}
        <Clickable className={styles.modalBtn} onClick={onOk}>
          {GCPI18n({ id: 'lb_reduce_success_btn' })}
        </Clickable>
      </div>
    </Modal>
  );
};

// export default WinPrizeModal;
export default connect(({ index }) => ({
  isPto: index.isPto,
}))(WinPrizeModal);
